<template>
  <div>
    <!-- capacity 是扩容用于处理页面悬停按钮使用 -->
    <component :colors="colors" :capacity="capacity" :headimg="headimg" :routArg="routArg"  :is="isComponent"></component>
  </div>
</template>
<script>
import { getSessionStorage } from '@/utils/tools'
import header from './header-child/public-header'
import header2 from './header-child/public-header2'
export default {
  data() {
    return {
      isComponent:''
    }
  },
  components:{
    header,
    header2
  },
  props: {
    colors: {
      type: String,
      default: ""
    },
    headimg: {
      type: String,
      default: ""
    },
    capacity:{
      type:String,
      default:''
    },
    routArg: {
      type: Object,
      default: {}
    }
  },
  methods: {
    pullData(){
      // 判读是否bid等于2
      if(getSessionStorage('request','/bid') && getSessionStorage('request','/bid')==2){
         this.isComponent = header2;
      }else{
        this.isComponent = header;
      }
    }
  },
  created() {
    this.pullData();
  }
}
</script>
<style lang="scss" scoped>

</style>